import React, { useState, useEffect } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [text, setText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const fullText = "Farmnet provides digital training solutions—empowering farmers with knowledge and skills through accessible mobile platforms and interactive learning tools.";

  useEffect(() => {
    let currentIndex = 0;
    let typingInterval;

    const typeText = () => {
      if (currentIndex < fullText.length) {
        setText(fullText.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setIsTyping(false);
          setTimeout(() => {
            backspaceText();
          }, 2000);
        }, 1000);
      }
    };

    const backspaceText = () => {
      let backspaceInterval;
      let backspaceIndex = fullText.length;

      const eraseText = () => {
        if (backspaceIndex >= 0) {
          setText(fullText.substring(0, backspaceIndex));
          backspaceIndex--;
        } else {
          clearInterval(backspaceInterval);
          setIsTyping(true);
          currentIndex = 0;
          typingInterval = setInterval(typeText, 50);
        }
      };

      backspaceInterval = setInterval(eraseText, 20);
    };

    if (isTyping) {
      typingInterval = setInterval(typeText, 50);
    }

    return () => {
      clearInterval(typingInterval);
    };
  }, [isTyping, fullText]);

  return (
    <div className="relative bg-[#F3F3F3]">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center p mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3 ">
          <span className='text-[#152C24]'>INSIGHTS & INNOVATIONS</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-2 border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Records Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2 md:mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[180px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
              <>
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751380764/Rectangle_34641498_kaiuit.png"
                  alt="Mobile"
                  className="object-cover w-full h-full"
                />
              </>
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
          <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3 text-[#979797]">
            INSIGHTS & INNOVATIONS | <span className='text-[#152C24]'>Training</span>
          </h1>
          
          <h2 className="text-[12px] md:text-[36px] font-bold text-[#152C24]">
            🎓 What Is Digital Training in Agriculture?
          </h2>
          
          <p className="md:text-[32px] text-[8px]">
            Digital training refers to the use of digital tools like mobile phones, online platforms, apps, videos, and social media to educate and train farmers on best agricultural practices, technologies, and business skills.
          </p>
          
          <p className="md:text-[32px] text-[8px]">
            It replaces or complements traditional in-person training by making learning accessible, affordable, and flexible, especially for farmers in rural or remote areas.
          </p>
          
          <h2 className="text-[12px] md:text-[36px] font-bold text-[#152C24]">
            🌍 How Smallholder Farmers in Africa Use Digital Training
          </h2>
          
          <p className="md:text-[32px] text-[8px]">
            Across Africa, smallholder farmers are using digital training tools to gain knowledge on:
          </p>
          
          <ul className="md:text-[32px] text-[8px] list-disc pl-5 space-y-2">
            <li>Crop production and protection</li>
            <li>Soil health and fertility management</li>
            <li>Livestock care</li>
            <li>Climate-smart agriculture</li>
            <li>Financial literacy and agribusiness skills</li>
            <li>Market access and value addition</li>
          </ul>
          
          <ol className="md:text-[32px] text-[8px] list-decimal pl-5 space-y-3 [&>li::marker]:font-bold">
            <li>
              <span className="font-bold">Mobile-Based Learning Apps</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Interactive apps with step-by-step farming guides</li>
                <li>Available in local languages for better understanding</li>
                <li>Offline access for areas with poor connectivity</li>
              </ul>
            </li>
            <li>
              <span className="font-bold">SMS & Voice Message Services</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Daily or weekly tips sent via text messages</li>
                <li>Interactive voice response (IVR) systems for non-literate farmers</li>
                <li>Q&A services where farmers can text questions</li>
              </ul>
            </li>
            <li>
              <span className="font-bold">Video Training Modules</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Demonstration videos showing practical techniques</li>
                <li>Shared via WhatsApp groups or memory cards</li>
                <li>Farmer-to-farmer video learning circles</li>
              </ul>
            </li>
            <li>
              <span className="font-bold">Online Farmer Communities</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Social media groups for knowledge sharing</li>
                <li>Discussion forums moderated by experts</li>
                <li>Peer learning networks</li>
              </ul>
            </li>
            <li>
              <span className="font-bold">E-Learning Platforms</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Structured courses with certification</li>
                <li>Progress tracking and assessments</li>
                <li>Integration with extension services</li>
              </ul>
            </li>
            <li>
              <span className="font-bold">Farmnet's Training Solutions</span>
              <ul className="list-disc pl-5 mt-1">
                <li>Personalized learning paths based on farmer needs</li>
                <li>Multimedia content (text, audio, video)</li>
                <li>Gamification elements to encourage engagement</li>
                <li>Integration with advisory services</li>
              </ul>
            </li>
          </ol>
<div>
<h2 className="text-[12px] md:text-[36px] font-bold text-[#152C24]">
            ✅ Benefits for Smallholder Farmers
          </h2>
          
          <p className="md:text-[32px] text-[8px]">
            Digital training helps farmers to:
          </p>
          
          <ul className="md:text-[32px] text-[8px] list-disc pl-5 space-y-2">
            <li>Access expert knowledge anytime, anywhere</li>
            <li>Learn at their own pace and convenience</li>
            <li>Receive timely, seasonally relevant information</li>
            <li>Reduce costs associated with travel to training centers</li>
            <li>Improve farming practices and productivity</li>
            <li>Connect with a community of fellow farmers</li>
          </ul>
</div>          
        </div>
        
        <div className='flex justify-end items-center'>
          <div>
            <h1 className="text-[18px] md:text-[32px] font-bold mt-2 mb-4 text-black">
              Download App
            </h1>
            <div className="md:w-[450px]">
              <div className="flex flex-row justify-between space-x-2 items-center sm:space-y-0">
                <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">   
             <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />    
             <p className="md:text-[14px] text-[6px] md:-mt-12 md:pl-5 font-normal md:px-1">
             Click to download App
  </p>
     </a>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
                  alt="Google Play"
                  className="h-[30px] md:h-[75px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;